var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-swipe',{attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.imgList),function(item,index){return _c('van-swipe-item',{key:index},[_c('img',{attrs:{"src":item.picturePath,"alt":""},on:{"click":function($event){return _vm.openUrl(item.bannerUrl)}}})])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0c07ad8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/Carousel.vue
// module id = null
// module chunks = 